import { SpeakersPage } from './views';

let routes = [
    {
        path: '/speakers',
        name: 'speakers',
        component: SpeakersPage,
        meta: {
            title: 'Голоса — Speechki',
        },
    },
];

export default routes;
